import { createElement } from 'react';
const Link = (props) => {
    const { title, href, target, ...others } = props;
    return createElement("a", Object.assign({ href: href, target: target }, others), title);
};
export default Link;
